import Users from "../views/admin/users/Index";
import UserEdit from "../views/admin/users/Edit";
import UserCreate from "../views/admin/users/Create";
import Occupations from "../views/admin/Occupations";
import { default as Services } from "../views/admin/services/Index";

import Vendors from "../views/vendors/Index";
import VendorsCreate from "../views/vendors/Create";
import VendorsImport from "../views/vendors/Import";
import NotificationsSettings from "../views/admin/notifications-settings/Index";
import NotificationsSettingsEdit from "../views/admin/notifications-settings/Edit";
import Reports from "../views/admin/users/Reports";

const admin = [
  {
    path: "/admin/vendors",
    component: Vendors,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/vendors/create",
    component: VendorsCreate,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/vendors/import",
    component: VendorsImport,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/services",
    component: Services,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/occupations",
    component: Occupations,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/users",
    component: Users,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/user-reports",
    component: Reports,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/users/add",
    component: UserCreate,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/users/:id/edit",
    component: UserEdit,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/notifications-settings",
    component: NotificationsSettings,
    meta: {
      admin: true,
    },
  },
  {
    path: "/admin/notifications-settings/:id/edit",
    component: NotificationsSettingsEdit,
    meta: {
      admin: true,
    },
  },
];
export default admin;
